<template>
  <a-flex class="wrapper" align="center" justify="center">
    Раздел в разработке
  </a-flex>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";
import { onMounted } from "vue";

const router = useRouter();

onMounted(() => {
  setTimeout(() => router.push({ name: "combineProductsBySize" }), 2000);
});
</script>

<style scoped lang="scss">
.wrapper {
  height: 100%;
  width: 100%;
  font-size: 24px;
}
</style>
